<template>
	<div :class="itemClass" v-html="cellTextData" @click.exact="selected" @click.shift="selectedShift"></div>
</template>

<script setup lang="ts">
	import {ref, computed} from "vue";
	
	const props = defineProps({
		textData: String,
		position: String,
		selected: Boolean
	});
	
	const emit = defineEmits(['selected']);
	
	const itemClass = computed(() => ({
		"mergeField": true,
		"mergeBox": true,
		"leftBox" : props.position==="left",
		"rightBox": props.position==="right",
		"mergeSelBox": props.selected
	}));
	
	const cellTextData = computed(() => {
		return props.textData?props.textData:"&nbsp;";
	});
	
	function selected() {
		emit('selected',props.position, false);
	}
	
	function selectedShift() {
		emit('selected',props.position, true);
	}
</script>

<style>
	.mergeField {
		user-select: none;
		-webkit-user-select: none;
	}
</style>
